module.exports = __webpack_public_path__ + "static/img/bemVindoDemandas.7e82881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bemVindoDemandas.png
// module id = Rqj5
// module chunks = 11